import axios from 'axios';

axios.interceptors.request.use(request => {
    // var ciphertext = CryptoJS.AES.encrypt(JSON.stringify('blrREmxgNZjjj3g3ejVOmw=='), process.env.REACT_APP_KEY_ENCRYP_DECRYPT).toString();
    // console.log(ciphertext);

        //var bytes = CryptoJS.AES.decrypt(process.env.REACT_APP_PASSWORD, process.env.REACT_APP_KEY_ENCRYP_DECRYPT);
        //    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            request.baseURL = request.baseURL || process.env.REACT_APP_BASE_URL;
        //     request.auth = {
        //         username: process.env.REACT_APP_USERNAME,=
        //         password: decryptedData
        // };
        return request;
    }, error => {
        return Promise.reject(error);
});

axios.interceptors.response.use(
    response => response,
    error => {
        // if (error.response.status === 401) {
        //     console.log('err')
        // }
        return Promise.reject(error);
    },
);

export default axios;
